// extracted by mini-css-extract-plugin
export default {"logo":"components-Shared-Logo-themes-GOP-styles__logo--vFCG2","isCheckoutPage":"components-Shared-Logo-themes-GOP-styles__isCheckoutPage--eUKhk"};